
import type { QuizGeneralSettings, QuizBrowserSettings, TakeQuizQuestion, QuizResult } from '@/types/takeQuiz';

export const actionTypes = {
  SET_QUIZ_PROGRESS: 'SET_QUIZ_PROGRESS',
  RESET_QUIZ_PROGRESS: 'RESET_QUIZ_PROGRESS',
  SET_QUIZ_PROGRESS_VALUE: 'SET_QUIZ_PROGRESS_VALUE',
  SET_QUIZ_GENERAL_SETTINGS: 'SET_QUIZ_GENERAL_SETTINGS',
  SET_QUIZ_BROWSER_SETTINGS: 'SET_QUIZ_BROWSER_SETTINGS',
  SET_TAKE_QUIZ_QUESTION: 'SET_TAKE_QUIZ_QUESTION',
  SET_QUIZ_RESULT: 'SET_QUIZ_RESULT',
  SET_COMPLETE_QUESTION: 'SET_COMPLETE_QUESTION',
  SET_IS_TIMEOUT_FORCE_SUBMIT: 'SET_IS_TIMEOUT_FORCE_SUBMIT',
  SET_IS_SECURITY_SUBMIT: 'SET_IS_SECURITY_SUBMIT',
  SET_IS_LOADING: 'SET_IS_LOADING',
  UPDATE_BROWSER_SETTINGS :'UPDATE_BROWSER_SETTINGS',
  QUIZ_REPORTS_FILTER: 'QUIZ_REPORTS_FILTER',
  SET_QUIZ_TITLE: 'SET_QUIZ_TITLE',
  SET_CURRENT_QUIZ_ID: 'SET_CURRENT_QUIZ_ID',
  UPDATE_USER_OFFLINE_COUNT: 'UPDATE_USER_OFFLINE_COUNT',
  SET_IS_USER_OFFLINE: 'SET_IS_USER_OFFLINE'
} as const;

export const actionCreators = {
  setQuizProgress: () => ({ type: actionTypes.SET_QUIZ_PROGRESS }),
  resetQuizProgress: () => ({ type: actionTypes.RESET_QUIZ_PROGRESS }),
  setQuizProgressValue: (value: number) => ({ type: actionTypes.SET_QUIZ_PROGRESS_VALUE, payload: value }),
  setQuizGeneralSettings: (settings: QuizGeneralSettings) => ({ type: actionTypes.SET_QUIZ_GENERAL_SETTINGS, payload: settings }),
  setQuizBrowserSettings: (settings: QuizBrowserSettings) => ({ type: actionTypes.SET_QUIZ_BROWSER_SETTINGS, payload: settings }),
  setTakeQuizQuestion: (question: TakeQuizQuestion) => ({ type: actionTypes.SET_TAKE_QUIZ_QUESTION, payload: question }),
  setQuizResult: (result: QuizResult) => ({ type: actionTypes.SET_QUIZ_RESULT, payload: result }),
  setCompleteQuestion: (count: number) => ({ type: actionTypes.SET_COMPLETE_QUESTION, payload: count }),
  setIsTimeOutForceSubmit: (isTimeout: boolean) => ({ type: actionTypes.SET_IS_TIMEOUT_FORCE_SUBMIT, payload: isTimeout }),
  setIsSecuritySubmit: (isSecurity: boolean) => ({ type: actionTypes.SET_IS_SECURITY_SUBMIT, payload: isSecurity }),
  setIsLoading: (isLoading: boolean) => ({ type: actionTypes.SET_IS_LOADING, payload: isLoading }),
  updateBrowserSettings: (settings: Partial<QuizBrowserSettings>) => ({
    type: actionTypes.UPDATE_BROWSER_SETTINGS, payload:settings
  }),
  setQuizReportsFilter: (filter: Record<string, unknown>) => ({ type: actionTypes.QUIZ_REPORTS_FILTER, payload: filter }),
  setCurrentQuizResultId: (id: string) => ({ type: actionTypes.SET_CURRENT_QUIZ_ID, payload: id }),
  updateUserOfflineCount: () => ({ type: actionTypes.UPDATE_USER_OFFLINE_COUNT }),
  setIsUserOffline: (isOffline: boolean) => ({ type: actionTypes.SET_IS_USER_OFFLINE, payload: isOffline }),
  setQuizTitle: (title: string) => ({ type: actionTypes.SET_QUIZ_TITLE, payload: title })
};

export type TakeQuizAction = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;